import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getLabel } from '../../InitData';
import { getCurrencyValue, getConfiguration } from '../../data/utils';

function BetOptionsSection(props) {
	const betslipContext = useContext(BetslipContext) ;
	const rawData  = betslipContext.getBetOptionsData();
    const betOptionsData =rawData?  rawData : {freebets : [], funbonuses : []};    
    const checkedValue = betslipContext.getBetOptionsSelection();
    const conf = getConfiguration();
    const nDec = conf.cs.nd;
    const mult = conf.cs.m;
    const currency = conf.cs.ct;
    
    let choosenFreebetName = '';
    let choosenFunbonusName = '';
    let amountFreebet = 0;
    let amountFunbonus = 0;
    
    for(let kb in betOptionsData.freebets){
		amountFreebet += betOptionsData.freebets[kb].importo;
		if(checkedValue?.type === 'freebet' && betOptionsData.freebets[kb].id_bonus == checkedValue.value){
			choosenFreebetName = betOptionsData.freebets[kb].sigla_promo + " " + checkedValue.value;
		}
    }
    
	for(let kb in betOptionsData.funbonuses){
		amountFunbonus += betOptionsData.funbonuses[kb].importo;
		if(checkedValue?.type === 'funbonus' && betOptionsData.funbonuses[kb].id_bonus == checkedValue.value){
			choosenFunbonusName = betOptionsData.funbonuses[kb].sigla_promo + " " + checkedValue.value;
		}
	}
    
    function handleChange(type){
    	if((type === 'freebet' && choosenFreebetName != '') || (type === 'funbonus' && choosenFunbonusName != '')){
    		betslipContext.setBetOptionsSelection('REAL', null)    	
    	}
    	else{
    		showOptions(type);
    	}
    
    }
    
    function showOptions(type){
    	function selectorFunction(value, type){
    		betslipContext.setBetOptionsSelection(value, type);
    	}
    	window.showBetOptionsModal(type === 'freebet'? betOptionsData.freebets : betOptionsData.funbonuses, type, checkedValue, selectorFunction);
    }
    
    return ( <>
	        <div className="bet-options-selectors-container">
	            {/*<div className="betslip-container-switch-bet-option-selector">
	                <label className="custom-switch-2 mr-2">
	                    <input id="realMoneyBtn" type="checkbox" onChange={() => betslipContext.setBetOptionsSelection('REAL', null)} checked={!checkedValue || checkedValue.value === 'REAL'}></input>
	                    <span className="custom-slider-2 round"></span>
	                </label>
	            	<span>{getLabel('carrello.fun_bonus.use_real_money')}</span>
	            </div>
	            */}
	        {
	        	betOptionsData.freebets.length > 0 && <div className="betslip-container-switch-bet-option-selector">
	                <label className="custom-switch-2 mr-2 bet-option-selector">
	                    <input id="freebetBtn" type="checkbox" onChange={() => handleChange('freebet')} checked={checkedValue && checkedValue.type === 'freebet'}></input>
	                    <span className="custom-slider-2 round"></span>
	                </label>
	            	<span onClick={() => {showOptions('freebet')}} className={"bet-option-span pointer"}> {choosenFreebetName !== ''? choosenFreebetName : getLabel('mybets.freebet') + " " + getCurrencyValue(amountFreebet, mult, nDec, currency)}</span>
	        	</div>
	        }
	        {
	        	betOptionsData.funbonuses.length > 0 && <div className="betslip-container-switch-bet-option-selector">
	                <label className="custom-switch-2 mr-2 bet-option-selector">
	                    <input id="funbonusBtn" type="checkbox" onChange={() =>  handleChange('funbonus')} checked={checkedValue && checkedValue.type === 'funbonus'}></input>
	                    <span className="custom-slider-2 round"></span>
	                </label>
	            	<span onClick={() => {showOptions('funbonus')}} className={"bet-option-span pointer"}> {choosenFunbonusName !== ''? choosenFunbonusName : getLabel('mybets.funbonus') + " " + getCurrencyValue(amountFunbonus, mult, nDec, currency)}</span>
	        	</div>
	        }
        </div>
    </>
    );
}

export default BetOptionsSection;